export default __webpack_public_path__ + "static/media/germany.47791470.svg";